import { Component, ViewChild, OnInit } from '@angular/core';

@Component({
    selector: 'faq',
    templateUrl: './faq.component.html',
    styleUrls: ['../pre-login.component.scss']
})
export class FAQComponent implements OnInit {
    ngOnInit() {
        window.scrollTo(0, 0);
    }
    constructor() { }
}


// WEBPACK FOOTER //
// ./src/app/components/customer-pre-login/faq/faq.component.ts